import { combineReducers } from '@reduxjs/toolkit';
import configDataSlice from './configDataSlice';
import emailReducer from './sendEmailSlice';

export const rootReducer = combineReducers({
    emailReducer: emailReducer,
    appConfigReducer: configDataSlice.reducer
  })
  